<template>
  <div :class="{ pinned: pinned }">
    <vue-draggable-resizable
      transition="fade-transition"
      :w="300"
      :h="200"
      v-if="pinned"
      :resizable="true"
      :y="92"
    >
      <v-flex xs12>
        <v-card class="elevation-6">
          <v-toolbar
            dark
            card
            dense
            height="32"
            :color="netProfitColor"
            class="bordered white--text"
          >
            <v-icon small pa-0 color="white">monetization_on</v-icon>
            <v-toolbar-title style="margin-left: 8px;">
              <h6>{{ previsional ? "Provisional Score" : "Real Score" }}</h6>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-icon small v-if="!pinned" @click="pinned = true">tab</v-icon>
            <v-icon small v-if="pinned" @click="pinned = false"
              >call_to_action</v-icon
            >
          </v-toolbar>

          <v-layout row justify-end></v-layout>
          <v-card-title style="padding-top: 0px; padding-bottom: 0px;">
            <v-layout column>
              <v-layout row my-3>
                <v-layout column justify-begin>
                  <h4>Net Profit per mt :</h4>
                  <h4>Net profit % :</h4>
                </v-layout>

                <v-layout column justify-end align-end>
                  <div>
                    <showMaybeValue
                      :value="inScoreCurrency(netProfitPerMT)"
                      :assertion="totalProductsNetWeight != 0"
                      warningMessage="Total products net Weight should not be null"
                    />
                  </div>
                  <div>
                    <showMaybeValue
                      :value="netProfitRatio + '%'"
                      :assertion="currentSellingPrice != 0"
                      warningMessage="Total selling price should not be null"
                    />
                  </div>
                </v-layout>
              </v-layout>
              <template>
                <div style="padding-top: 8px;" v-show="netProfit < 0">
                  <v-layout row>
                    <v-layout justify-begin>
                      <div>Total selling price :</div>
                    </v-layout>
                    <v-layout justify-end>
                      <div class="ml-3">
                        {{ inScoreCurrency(currentSellingPrice) }}
                      </div>
                    </v-layout>
                  </v-layout>
                  <v-layout row>
                    <v-layout justify-begin>
                      <div>Total buying price :</div>
                    </v-layout>
                    <v-layout justify-end>
                      <div class="ml-3">
                        -
                        {{ inScoreCurrency(currentBuyingPrice) }}
                      </div>
                    </v-layout>
                  </v-layout>
                  <v-layout row @click="togglePanel()" class="clickable">
                    <v-layout column justify-begin>
                      <div>
                        Total charges
                        <v-icon small>keyboard_arrow_down</v-icon>:
                      </div>
                    </v-layout>
                    <v-layout justify-end>
                      <div class="ml-3">
                        - {{ inScoreCurrency(totalChargesCost) }}
                      </div>
                    </v-layout>
                  </v-layout>

                  <v-expansion-panel popout expand v-model="panel">
                    <v-expansion-panel-content
                      v-for="(item, i) in 1"
                      :key="i"
                      class="elevation-0"
                      hide-actions
                    >
                      <v-card>
                        <v-layout
                          row
                          v-for="scoreCostLine of currentScoreCosts"
                          :key="scoreCostLine[0].name"
                        >
                          <v-layout justify-begin>
                            <div :title="scoreCostLine[0].name">
                              {{ truncate(scoreCostLine[0].name) }}
                              :
                            </div>
                          </v-layout>
                          <v-layout justify-end>
                            <div>
                              {{ getLinesCostWithCurrency(scoreCostLine) }}
                            </div>
                          </v-layout>
                        </v-layout>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </div>
              </template>
              <v-divider style="padding-bottom: 8px;"></v-divider>
              <v-layout align-end justify-center row fill-height>
                <v-flex text-xs-center>
                  <h3 align-center row v-bind:style="{ color: netProfitColor }">
                    {{ inScoreCurrency(netProfit) }}
                  </h3>
                  <p align-center class="font-weight-medium font-italic">
                    Net Profit
                  </p>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-card-title>
        </v-card>
      </v-flex>
    </vue-draggable-resizable>
    <v-flex xs12 v-if="!pinned">
      <v-card>
        <v-toolbar
          dark
          card
          dense
          height="32"
          :color="netProfitColor"
          class="bordered white--text"
        >
          <v-icon small pa-0 color="white">monetization_on</v-icon>
          <v-toolbar-title style="margin-left: 8px;">
            <h6>{{ previsional ? "Provisional Score" : "Real Score" }}</h6>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon small v-if="!pinned" @click="pinned = true">tab</v-icon>
          <v-icon small v-if="pinned" @click="pinned = false"
            >call_to_action</v-icon
          >
        </v-toolbar>

        <v-card-title primary-title class="pt-0">
          <v-layout column>
            <v-layout row my-3>
              <v-layout column justify-begin>
                <h4>Net Profit per mt:</h4>
                <h4>Net profit %:</h4>
              </v-layout>
              <v-layout column justify-end align-end>
                <div>
                  <showMaybeValue
                    :value="inScoreCurrency(netProfitPerMT)"
                    :assertion="totalProductsNetWeight != 0"
                    warningMessage="Total products net Weight should not be null"
                  />
                </div>
                <div>
                  <showMaybeValue
                    :value="netProfitRatio + '%'"
                    :assertion="currentSellingPrice != 0"
                    warningMessage="Total selling price should not be null"
                  />
                </div>
              </v-layout>
            </v-layout>
            <v-layout row>
              <v-layout justify-begin>
                <div>Total selling price:</div>
              </v-layout>
              <v-layout justify-end>
                <div class="ml-3">
                  {{ inScoreCurrency(currentSellingPrice) }}
                </div>
              </v-layout>
            </v-layout>
            <v-layout row>
              <v-layout justify-begin>
                <div>Total buying price:</div>
              </v-layout>
              <v-layout justify-end>
                <div class="ml-3">
                  -{{ inScoreCurrency(currentBuyingPrice) }}
                </div>
              </v-layout>
            </v-layout>
            <v-layout row>
              <v-layout justify-begin>
                <div title="Bank Charges">
                  Bank charges:
                </div>
              </v-layout>
              <v-layout justify-end>
                -{{ inScoreCurrency(contract.total_bank_charges_amount_for_score) }}
              </v-layout>
            </v-layout>

            <v-layout row @click="togglePanel()" class="clickable">
              <v-layout column justify-begin>
                <div>
                  Total charges
                  <v-icon small>keyboard_arrow_down</v-icon>:
                </div>
              </v-layout>
              <v-layout justify-end>
                <div class="ml-3">
                  - {{ inScoreCurrency(totalChargesCost) }}
                </div>
              </v-layout>
            </v-layout>
            <v-expansion-panel popout expand v-model="panel" class="pb-4">
              <v-expansion-panel-content
                v-for="(item, i) in 1"
                :key="i"
                class="elevation-0"
                hide-actions
              >
                <v-card>
                  <v-layout
                    row
                    v-for="scoreCostLine of currentScoreCosts"
                    :key="scoreCostLine[0].name"
                  >
                    <v-layout justify-begin>
                      <div>{{ scoreCostLine[0].name }} :</div>
                    </v-layout>
                    <v-layout justify-end>
                      <div>{{ getLinesCostWithCurrency(scoreCostLine) }}</div>
                    </v-layout>
                  </v-layout>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-divider style="padding-bottom: 8px;"></v-divider>
            <v-layout align-end justify-center row fill-height>
              <v-flex text-xs-center>
                <h1 align-center row v-bind:style="{ color: netProfitColor }">
                  {{ inScoreCurrency(netProfit) }}
                </h1>
                <h4 align-center class="font-weight-medium">NET PROFIT</h4>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-title>
      </v-card>
    </v-flex>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import scoreCost from "../../mixins/scoreCost";
import showMaybeValue from "../shared/showMaybeValue";
import VueDraggableResizable from "vue-draggable-resizable";

export default {
  name: "totalScore",
  mixins: [scoreCost],
  components: {
    VueDraggableResizable,
    showMaybeValue,
  },
  props: {
    previsional: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      panel: [],
      pinned: false,
    };
  },
  computed: {
    ...mapGetters("contractStore", [
      "contract",
      "totalSellingPrice",
      "totalSellingPriceScoreCurrency",
      "totalBuyingPrice",
      "totalBuyingPriceScoreCurrency",
      "previsional_score_costs",
      "score_costs",
    ]),
    currentScoreCosts() {
      return this.previsional ? this.previsional_score_costs : this.score_costs;
    },
    currentSellingPrice() {
      return this.totalSellingPriceScoreCurrency(this.previsional);
    },
    currentBuyingPrice() {
      return this.totalBuyingPriceScoreCurrency(this.previsional);
    },
    totalChargesCost() {
      var chargesCost = 0;
      Object.keys(this.currentScoreCosts).forEach((key) => {
        chargesCost += this.getLinesCost(this.currentScoreCosts[key]);
      });
      return chargesCost;
    },
    netProfit() {
      return this.rounded(
        this.totalSellingPriceScoreCurrency(this.previsional) -
          this.totalBuyingPriceScoreCurrency(this.previsional) -
          this.totalChargesCost - this.contract.total_bank_charges_amount_for_score
      );
    },
    netProfitColor() {
      return this.netProfit > 0 ? `#50a55c` : `#da4545`;
    },
    netProfitRatio() {
      return this.rounded(
        (this.netProfit /
          this.totalSellingPriceScoreCurrency(this.previsional)) *
          100
      );
    },
    totalProductsNetWeight() {
      if (!this.previsional)
        return this.contract.real_product_trades
          .filter((e) => e.id != "")
          .map((e) => e.net_weight)
          .reduce((v, a) => a + v, 0);
      else
        return this.contract.product_trades
          .filter((e) => e.id != "")
          .map((e) => e.net_weight)
          .reduce((v, a) => a + v, 0);
    },
    netProfitPerMT() {
      return this.rounded(this.netProfit / this.totalProductsNetWeight);
    },
  },
  methods: {
    rounded(num) {
      return Number(num.toFixed(2));
    },
    togglePanel() {
      if (this.panel.length > 0) this.panel = [];
      else this.panel = [true];
    },
    truncate(input) {
      if (input.length > 15) return input.substring(0, 15) + "...";
      else return input;
    },
    getLinesCost(lines) {
      var cost = 0;
      lines.forEach((line) => {
        cost += this.getScoreCost(line);
      });
      return cost;
    },
    getLinesCostWithCurrency(lines) {
      const cost = this.getLinesCost(lines) * -1;
      return this.inScoreCurrency(cost);
    },
  },
};
</script>

<style scoped>
.clickable {
  cursor: pointer;
}

.pinned {
  cursor: grab;
  position: fixed;
  right: 300px;
  top: 0px;
  width: auto;
}
</style>
